import React from 'react';
import {Typography} from "@material-ui/core";

export const NotImplemented = () => (
  <Typography>Asset Render not implemented</Typography>
);
